import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["list"]
  static values = { reorderUrl: String }

  connect() {
    if (!this.hasListTarget) return
    this.sortable = Sortable.create(this.listTarget, {
      animation: 150,
      handle: ".fa-grip-vertical",
      onEnd: this.persist.bind(this)
    })
  }

  disconnect() {
    this.sortable?.destroy()
  }

  persist() {
    const ids = Array.from(this.listTarget.querySelectorAll("[data-block-id]")).map(el => el.dataset.blockId)
    const token = document.querySelector('meta[name="csrf-token"]')?.content
    const data = new FormData()
    ids.forEach(id => data.append("ids[]", id))

    fetch(this.reorderUrlValue, {
      method: "PATCH",
      headers: { "X-CSRF-Token": token, Accept: "application/json" },
      body: data,
      credentials: "same-origin"
    })
  }
}
